import { render, staticRenderFns } from "./ContractStrandard.vue?vue&type=template&id=63d11b34&scoped=true&"
import script from "./ContractStrandard.vue?vue&type=script&lang=js&"
export * from "./ContractStrandard.vue?vue&type=script&lang=js&"
import style0 from "./ContractStrandard.vue?vue&type=style&index=0&id=63d11b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d11b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
